import { FC } from 'react'

import clsx from 'clsx'

import { Txt } from 'src/components/atoms'

type Props = {
  isSelected: boolean
  text: string
  onClick: () => void
  className?: string
}

export const PageNavigationItem: FC<Props> = ({ isSelected, text, onClick, className }) => {
  return (
    <button
      type="button"
      className={clsx(
        'tw-outline-none',
        isSelected ? 'tw-cursor-default' : 'tw-cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <div
        className={clsx(
          isSelected
            ? 'tw-bg-roovPrimary-default hover:tw-bg-roovPrimary-activePressed tw-text-surface-primary'
            : 'tw-bg-surface-primary hover:tw-bg-surface-secondary',
          'tw-h-s5 tw-pl-s0 tw-flex tw-items-center'
        )}
      >
        <Txt className="tw-font-bold tw-text-left">{text}</Txt>
      </div>
    </button>
  )
}
